import { render } from "./BathroomsValues.vue?vue&type=template&id=1a6697c6&scoped=true&ts=true"
import script from "./BathroomsValues.vue?vue&type=script&lang=ts"
export * from "./BathroomsValues.vue?vue&type=script&lang=ts"

import "./BathroomsValues.vue?vue&type=style&index=0&id=1a6697c6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6697c6"]])

export default __exports__